import { configureStore } from '@reduxjs/toolkit'
import { enhancedTmsApi } from '../API/rtk-query-api/store/enhancedTmsApi'
import * as reducers from './reducers'

const store = configureStore({
  reducer: {
    trainingMatrix: reducers.trainingMatrixReducer,
    trainingMatrixFilters: reducers.filtersReducer,
    gapAnalysis: reducers.gapAnalysisReducer,
    gapAnalysisFilters: reducers.gapAnalysisFiltersReducer,
    //
    [enhancedTmsApi.reducerPath]: enhancedTmsApi.reducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(enhancedTmsApi.middleware)
})

export default store

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
